import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Reusable connect button component with consistent layout and styling.
 * Wraps the app-button component with primary variant and link icon.
 */
@Component({
  selector: 'app-connect-button',
  templateUrl: './connect-button.component.html',
  styleUrls: ['./connect-button.component.scss'],
})
export class ConnectButtonComponent {
  /** Disables the button */
  @Input() disabled = false;

  /** Custom label for the button. Defaults to translation key 'admin.store.setting.connect' */
  @Input() label: string;

  /** Additional CSS classes for the button */
  @Input() classes = '';

  /** Whether to include the row/col layout wrapper. Set to false for inline usage */
  @Input() showLayout = true;

  /** Emits when the button is clicked */
  @Output() clickEvent = new EventEmitter<void>();

  /**
   * Handles button click and emits the clickEvent
   */
  onClick(): void {
    this.clickEvent.emit();
  }
}
